import { React, useState, useEffect } from 'react';
import { Box, Paper, Grid, Typography, Tabs, Tab } from '@mui/material';
import { History } from '@mui/icons-material';
import '../../App.css';
import AuditLogsTable from '../table-data/AuditLogsTable';
import { useNavigate } from 'react-router-dom';

function AuditLogs() {
  const [auditLogs, setAuditLogs] = useState([]);
  const [payrollProcessingLogs, setPayrollProcessingLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [payrollLoading, setPayrollLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAuditLogs = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/company-master/audit-logs`,
          {
            credentials: 'include',
          }
        );

        if (response.status === 200) {
          const data = await response.json();
          setAuditLogs(data.data || data || []);
        } else if (response.status === 401) {
          navigate('/');
        } else {
          setAuditLogs([]);
        }
      } catch (error) {
        console.error('Error fetching audit logs:', error);
        setAuditLogs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAuditLogs();
  }, [navigate]);

  useEffect(() => {
    const fetchPayrollProcessingLogs = async () => {
      setPayrollLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/company-master/payroll-processing-logs`,
          {
            credentials: 'include',
          }
        );

        if (response.status === 200) {
          const data = await response.json();
          setPayrollProcessingLogs(data.data || data || []);
        } else if (response.status === 401) {
          navigate('/');
        } else {
          setPayrollProcessingLogs([]);
        }
      } catch (error) {
        console.error('Error fetching payroll processing logs:', error);
        setPayrollProcessingLogs([]);
      } finally {
        setPayrollLoading(false);
      }
    };

    fetchPayrollProcessingLogs();
  }, [navigate]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        margin: '6px',
        padding: '30px',
        fontWeight: '500px',
        marginTop: '-10px',
      }}
    >
      <Paper elevation={0} sx={{ width: '100%', maxWidth: '1800px' }}>
        <Grid className="form-title" style={{ marginBottom: '-73px' }} container spacing={2}>
          <Grid item>
            <Typography variant="h5" sx={{ textAlign: 'center', margin: 5 }}>
              Logs
            </Typography>
          </Grid>
          <Grid item>
            <History style={{ marginLeft: '-30px' }} sx={{ width: 45, height: 45 }} />
          </Grid>
        </Grid>
        <Box sx={{ margin: '30px' }}>
          <Tabs value={activeTab} onChange={handleTabChange} sx={{ marginBottom: 3 }}>
            <Tab label="Audit Logs" />
            <Tab label="Payroll Processing Logs" />
          </Tabs>
          {activeTab === 0 && (
            <AuditLogsTable data={auditLogs} loading={loading} isPayrollProcessing={false} />
          )}
          {activeTab === 1 && (
            <AuditLogsTable data={payrollProcessingLogs} loading={payrollLoading} isPayrollProcessing={true} />
          )}
        </Box>
      </Paper>
    </Box>
  );
}

export default AuditLogs;
